import React from 'react';
import PropTypes from 'prop-types';

import { NotValidBanner } from '../NotValidBanner';

/**
 * Top Banner alert.
 * This component is manipulated by src/script.js L4
 * @returns React Component
 */
export const Alert = ({ hiddenKeyError, registrationError, clearErrors }) => (
  <div id="alert">
    {(hiddenKeyError || registrationError) && <NotValidBanner onClose={clearErrors} />}
  </div>
);

Alert.propTypes = {
  hiddenKeyError: PropTypes.bool,
  registrationError: PropTypes.bool,
  clearErrors: PropTypes.func,
};

Alert.defaultProps = {
  hiddenKeyError: false,
  registrationError: false,
  clearErrors: () => {},
};
